import React from 'react';
import Header from '../homepage/header';
import './FiveGLab.css';
import dot from './dot1.png'; // Replace with the path to the new 5G logo for the heading
import pdfImage from './5gLabImage.jpg'; // Path to the PDF image
import fivelab from './5glab-image.jpg';

function FiveGLab() {
  return (
    <div>
      <Header />
      <div className="heading-container">
        <img src={dot} alt="5G Logo" className="fiveG-logo" />
        <h1>5G Use Case Lab at NITK</h1>
      </div>
      <div className="lab-container">
        <div className="lab-text">
          <p>
          In 2023, NITK was awarded the 5G Use Case Lab by <strong>Shri Narendra Modi, Honourable Prime Minister of India</strong> to spearhead innovative research and applications in 5G technology. The lab focuses on exploring various use cases, particularly in rural and industrial scenarios, to harness the full potential of 5G technology.
          </p>
          <p>
            This lab is expected to contribute significantly to the development of smart solutions for connectivity challenges and foster innovation within the telecommunications field.
          </p>
          <h3>Objectives:</h3>
          <ul>
            <li>To build competencies and engagement in 5G technologies in students and the academic fraternity.</li>
            <li>To enable projects at UG and PG levels for students using the 5G environment.</li>
            <li>To encourage academia-industry engagement to ideate and develop 5G use cases.</li>
            <li>To provide local access to the 5G test setup for startups and MSMEs around the institution.</li>
            <li>Making Indian academia & startup ecosystem 6G ready.</li>
          </ul>
          <img src={fivelab} alt="5G Lab Award Document" className="five-image" />
          
          
        </div>
        <div className="pdf-container">
          <img src={pdfImage} alt="5G Lab Award Document" className="pdf-image" />
        </div>
      </div>
    </div>
  );
}

export default FiveGLab;
